import NBType from '@netbase/nb-type'
import SimpleChannelSchema from './SimpleChannelSchema'

/**
 * @typedef {import('./SimpleChannelSchema').SimpleChannel} SimpleChannel
 */

/**
 * @typedef {object} ChannelPostIdentifierSchema
 * @property {SimpleChannel} channel
 * @property {string} inputValue
 */
const ChannelPostIdentifierSchema = NBType.object().shape('ChannelPostIdentifierSchema', {
  /* @prop */
  channel: SimpleChannelSchema,
  /* @prop */
  inputValue: NBType.string()
  /* END */
})
export default ChannelPostIdentifierSchema
// RESERVE BELOW
